"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationAttributes = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const ratingTextStyles = {
    hyphens: 'auto',
    flex: '0 12 auto',
    wordBreak: 'break-word',
    mr: 2,
};
exports.destinationAttributes = (0, basic_1.applyBase)({
    ratingTextStyles,
    attributeWrap: {
        py: 3,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: 'lightGreyFirst',
        mb: '-1px',
        letterSpacing: '0.7px',
    },
    attributeItemWrap: Object.assign(Object.assign({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1, mb: 3 }, font_faces_1.FONT_SIZE.XS), { '.attributeName': Object.assign({}, ratingTextStyles) }),
    attributeDetailsList: Object.assign({ p: [3, 0] }, font_faces_1.FONT_SIZE.LARGE),
    attributeDetailWrap: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: [4, 0],
        '&:not(:last-child)': {
            mb: [2, 1],
        },
        '.attributeDetailName': Object.assign({}, ratingTextStyles),
        '.attributeRatingWrap': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    attributeDetailWrapMobile: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 4,
        mb: 2,
        '.attributeDetailName': Object.assign({}, ratingTextStyles),
        '.attributeRatingWrap': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    attributeWrapMobile: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: 1,
        '.attributeName': Object.assign(Object.assign({}, ratingTextStyles), { fontWeight: 'bold' }),
        '.ratingWrap': {
            display: 'flex',
            flex: '0 0 auto',
            ml: 2,
        },
    },
    destinationRatingStyles: {
        backgroundColor: 'black',
        height: ['19px', '15px'],
        width: ['19px', '15px'],
        borderRadius: 'circle',
        '&:not(:last-child)': {
            mr: 1,
        },
    },
    destinationRatingSubStyles: {
        backgroundColor: 'primary',
        height: ['14px', '14px', '15px'],
        width: ['14px', '14px', '15px'],
        borderRadius: 'circle',
        '&:not(:last-child)': {
            mr: 1,
        },
    },
    destinationRemainRatingStyles: {
        backgroundColor: 'lightGreyFirst',
    },
    destinationRemainRatingSubStyles: {
        backgroundColor: 'lightGreyFirst',
    },
});
//# sourceMappingURL=destination-attributes.js.map